import { HTTP } from "./common"

export default {
    getClientProfile(clientId) {
        let urlString = `clients/${clientId}`
        return HTTP.get(urlString)
            .then(response => response.data)
    },
    getClientPortfolio(clientId) {
        let urlString = `clients/${clientId}/portfolio`
        return HTTP.get(urlString)
            .then(response => response.data)
    },
    getClientDeals(clientId) {
        let urlString = `clients/${clientId}/deals`
        return HTTP.get(urlString)
            .then(response => response.data)
    },
    getClientProfitability(clientId, dates=[]) {
        let urlString = `clients/${clientId}/profitability`
        return HTTP.get(urlString, {
            params: {
                dates: dates
            }
        })
        .then(response => response.data)
    },
    async getClientBalanceChanges(clientId) {
        let urlString = `clients/${clientId}/balance_changes`
        const response = await HTTP.get(urlString)
        return response.data
    },
    async getClientPortfolioChanges(query) {
        let clientID = query.client_id
        let urlString = `clients/${clientID}/portfolio_changes`
        const response = await HTTP.get(urlString, {
            params: query
        })
        return response.data
    },
}
